import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminActionItemsQueryKey, transformActionItems } from "../action-item.keys";

export const useFetchAdminActionItems = () => {
	const { get } = useRequest();

	const actionItemsRequest = useQuery({
		queryKey: adminActionItemsQueryKey.all(),
		queryFn: async () => {
			const response = await get<Dtos.ActionItem.Get.Response[]>("/v2/action-items");
			return transformActionItems(response);
		},

		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
	});

	return {
		actionItems: actionItemsRequest.data,
		actionItemsIsLoading: actionItemsRequest.isLoading,
	};
};
